import { type FunctionComponent, useState } from 'react';

import { Link } from '@dr.pogodin/react-utils';

import Status from 'components/Status';
import RemoveBlogItemModal from 'components/admin/RemoveBlogItemModal';
import { type BlogItemT, P_ADMIN_BLOG, getId } from 'utils';

import IconEdit from 'assets/images/icon-edit-16px.svg';
import IconImage from 'assets/images/icon-image-16px.svg';

import IconTrash from 'assets/images/icon-trash-16px.svg';

import './style.scss';

type PropsT = {
  item: BlogItemT;
};

const Item: FunctionComponent<PropsT> = ({
  item,
}) => {
  const url = `${P_ADMIN_BLOG}/${getId(item)}`;

  const [showRemoveModal, setShowRemoveModal] = useState(false);

  return (
    <tr>
      <td styleName="w90">
        {item.image
          ? <img alt="Cover" src={item.imageThumbnail ?? ''} styleName="thumbnail" />
          : (
            <div styleName="imagePlaceholder">
              <IconImage />
            </div>
          )}
      </td>
      <td styleName="vAlignMiddle">
        <Link styleName="title" to={url}>
          {item.title}
        </Link>
      </td>
      <td data-label="Status" styleName="vAlignMiddle">
        <Status status={item.status} />
      </td>
      <td aria-label="Actions" styleName="vAlignMiddle">
        <div styleName="icons">
          <Link to={url}>
            <IconEdit />
          </Link>
          <Link
            onClick={() => {
              setShowRemoveModal(true);
            }}
            to=""
          >
            <IconTrash />
          </Link>
        </div>
        {showRemoveModal ? (
          <RemoveBlogItemModal
            blogId={getId(item)}
            onCancel={() => {
              setShowRemoveModal(false);
            }}
          />
        ) : null}
      </td>
    </tr>
  );
};

export default Item;
